import "./styles.scss";

import moment from "moment";
import classnames from "classnames";

import { ReactComponent as ArrowIcon } from "assets/icons/new/calendar-arrow.svg";

const mainClass = "calendar-months";

const CalendarMonths = ({
  date,
  setDate,
  selected_date,
  prev_date,
  next_date,
  onSelect,
}) => {
  const temp_date = moment(date)?.set("date", 1);
  const all_months = moment.monthsShort();
  const current_month = moment().month();
  const current_year = moment().year();

  let formatted_months = all_months?.map((item, index) => {
    const d = moment(temp_date).set("month", index);

    return {
      name: item,
      disabled: !!prev_date
        ? moment(prev_date).isAfter(d, "month")
        : !!next_date
        ? moment(next_date).isBefore(d, "month")
        : false,
    };
  });

  const selected = !!selected_date
    ? moment(selected_date)?.year() === moment(date)?.year()
      ? moment(selected_date).month()
      : null
    : null;

  const onChangeYear = (type) => {
    if (type === "prev") {
      setDate((prev) => moment(prev).add(-1, "years"));
    } else {
      setDate((prev) => moment(prev).add(1, "years"));
    }
  };

  const isCurrentMonth = (monthIndex) =>
    moment(date).year() === current_year && monthIndex === current_month;

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__header`}>
        <button
          className={`${mainClass}__header-arrow`}
          type="button"
          onClick={() => onChangeYear("prev")}
        >
          <ArrowIcon />
        </button>
        <span>{date?.year()}</span>
        <button
          className={`${mainClass}__header-arrow`}
          type="button"
          onClick={() => onChangeYear("next")}
        >
          <ArrowIcon />
        </button>
      </div>
      <div className={`${mainClass}__list`}>
        {formatted_months?.map((item, index) => (
          <button
            key={`${moment(date).year()}-${index}`}
            className={classnames({
              active: index === selected,
              current: isCurrentMonth(index),
            })}
            type="button"
            disabled={item?.disabled}
            onClick={() => onSelect(index)}
          >
            {item?.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CalendarMonths;
